import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { RemoveCartLineApiParameter } from "@insite/client-framework/Services/CartService";
import {
    DispatchBeginRemoveCartLine,
    DispatchCompleteRemoveCartLine,
    LoadCart,
    RemoveCartLine,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        cartId: string;
        cartLineId: string;
    },
    RemoveCartLineApiParameter
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        cartLineId: props.parameter.cartLineId,
        cartId: props.parameter.cartId,
    };
};

export const chain = [
    DispatchBeginRemoveCartLine,
    PopulateApiParameter,
    RemoveCartLine,
    LoadCart,
    DispatchCompleteRemoveCartLine,
];

const removeCartLine = createHandlerChainRunner(chain, "RemoveCartLine");
export default removeCartLine;
